<template>
    <div>
        <a
            class="btn btn-primary btn-raised btn-block"
            :href="`#/meetings/list?participants[]=${reviewCycle.revieweeUser._id}`"
            target="_blank"
        >
            <span>{{ $t(`userlist.show.btnMeeting`) }}</span>
        </a>
    </div>
</template>

<script>
export default {
    props: {
        reviewCycle: {
            type: Object,
            required: true,
        },
    },
};
</script>
